class CartQuantityValidator {
  constructor() {
    this.inventoryCache = new Map();
    this.isActive = false; // Standardmäßig deaktiviert

    // Aktiviere den Validator global, unabhängig von der aktuellen Seite
    this.checkIfAnyItemHasRohwarenbestand().then((isActive) => {
      if (isActive) {
        console.log("Rohwarenbestand-Validator aktiviert");
        this.isActive = true;
        this.setupMutationObserver();
        this.setupCartObserver();
        this.createModal();
      } else {
        console.log(
          "Rohwarenbestand-Validator deaktiviert - keine Artikel mit aktivem Metafield im Warenkorb"
        );
      }
    });
  }

  // Prüft, ob irgendein Artikel im Warenkorb das Rohwarenbestand-Metafield hat
  async checkIfAnyItemHasRohwarenbestand() {
    try {
      const cartResponse = await fetch("/cart.js");
      if (cartResponse.ok) {
        const cartData = await cartResponse.json();

        // Wenn der Warenkorb leer ist, trotzdem aktivieren (für zukünftige Hinzufügungen)
        if (!cartData.items || cartData.items.length === 0) {
          console.log(
            "Warenkorb ist leer, aktiviere Validator für zukünftige Artikel"
          );
          return true;
        }

        // Prüfe jedes Item im Warenkorb
        for (const item of cartData.items) {
          const variantData = await this.getVariantData(item.variant_id);
          if (variantData && variantData.sku && variantData.sku.trim() !== "") {
            const apiData = await this.getApiInventory(variantData.sku);
            if (this.hasRohwarenbestandMetafield(apiData)) {
              // Wenn mindestens ein Artikel das Metafield hat, aktiviere
              console.log(
                `Artikel ${item.title} hat Rohwarenbestand aktiviert`
              );
              return true;
            }
          }
        }
      }
    } catch (error) {
      console.error("Fehler beim Überprüfen des Warenkorbs:", error);
      // Im Fehlerfall aktivieren wir trotzdem, um auf der sicheren Seite zu sein
      return true;
    }

    // Selbst wenn keine aktuellen Artikel das Metafield haben, aktivieren wir
    // den Validator für zukünftige Hinzufügungen
    console.log(
      "Keine aktuellen Artikel mit Rohwarenbestand, aktiviere trotzdem für zukünftige Hinzufügungen"
    );
    return true;
  }

  createModal() {
    if (!document.getElementById("inventory-modal")) {
      const modal = document.createElement("div");
      modal.id = "inventory-modal";
      modal.innerHTML = `
                  <div class="inventory-modal-overlay" style="display: none; position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0,0,0,0.5); z-index: 9999;">
                      <div class="inventory-modal-content" style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); background: white; padding: 20px; border-radius: 4px; max-width: 90%; width: 400px; z-index: 10000;">
                          <h2 style="margin-top: 0;">Der Lagerbestand ist geplündert!</h2>
                          <p id="inventory-modal-message"></p>
                          <button id="inventory-modal-button" class="btn btn--medium btn--full btn--secondary">
                              Alles klar!
                          </button>
                      </div>
                  </div>
              `;
      document.body.appendChild(modal);

      // Event-Listener für den Button hinzufügen
      document
        .getElementById("inventory-modal-button")
        .addEventListener("click", () => {
          document.querySelector(".inventory-modal-overlay").style.display =
            "none";

          // Prüfe, ob wir auf der Warenkorb-Seite sind
          if (window.location.pathname.includes("/cart")) {
            console.log("Warenkorb-Seite wird neu geladen...");
            // Kurze Verzögerung, damit das Modal vollständig geschlossen ist
            setTimeout(() => {
              window.location.reload();
            }, 100);
          }
        });
    }
  }

  showModal(message) {
    if (!this.isActive) return;

    const modal = document.querySelector(".inventory-modal-overlay");
    const messageEl = document.getElementById("inventory-modal-message");
    if (modal && messageEl) {
      messageEl.textContent = message;
      modal.style.display = "block";
    }
  }

  setupMutationObserver() {
    // Beobachte DOM-Änderungen
    const observer = new MutationObserver((mutations) => {
      if (!this.isActive) return;

      for (const mutation of mutations) {
        if (mutation.addedNodes.length) {
          this.attachEventListeners();
        }
      }
    });

    // Beobachte den gesamten Body nach Änderungen
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    // Initial auch einmal ausführen
    this.attachEventListeners();
  }

  setupCartObserver() {
    // Überwache alle Cart-Change Events
    document.addEventListener("cart:change", async (event) => {
      if (!this.isActive) return;
      await this.validateCart();
    });

    // Überwache auch direkte Cart-Updates
    const originalFetch = window.fetch;
    window.fetch = async (...args) => {
      const [url, config] = args;

      try {
        if (
          (url.includes("/cart/add") || url.includes("/cart/change")) &&
          this.isActive
        ) {
          const response = await originalFetch(...args);

          if (url.includes("/cart/add")) {
            const cartData = await response.clone().json();
            const needsValidation = await this.validateCartAdd(cartData);

            if (needsValidation) {
              // Zeige Fehlermeldung unter dem Quantity-Feld
              const quantityInput = document.querySelector(
                ".product-form__quantity"
              );
              if (quantityInput) {
                let errorMessage = quantityInput.nextElementSibling;
                if (
                  !errorMessage ||
                  !errorMessage.classList.contains("quantity-error-message")
                ) {
                  errorMessage = document.createElement("div");
                  errorMessage.classList.add("quantity-error-message");
                  errorMessage.style.color = "var(--color-error)";
                  errorMessage.style.marginTop = "0.5rem";
                  errorMessage.style.fontSize = "1.3rem";
                  quantityInput.parentNode.insertBefore(
                    errorMessage,
                    quantityInput.nextSibling
                  );
                }
                errorMessage.textContent = `Maximal verfügbare Menge: ${needsValidation.totalAvailable} (Lager: ${needsValidation.originalQuantity}, Extern: ${needsValidation.baseQuantity})`;
              }

              // Warte auf die Cart-Änderung
              try {
                await fetch("/cart/change.js", {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify({
                    id: cartData.items[cartData.items.length - 1].key,
                    quantity: 0,
                  }),
                });

                // Hole den aktuellen Cart-Status
                const currentCartResponse = await fetch("/cart.js");
                if (currentCartResponse.ok) {
                  const currentCart = await currentCartResponse.json();
                  this.updateCartCount(currentCart.item_count);
                }
              } catch (error) {
                console.error("Fehler beim Cart Update:", error);
              }
            } else {
              // Entferne Fehlermeldung wenn vorhanden
              const errorMessage = document.querySelector(
                ".quantity-error-message"
              );
              if (errorMessage) {
                errorMessage.remove();
              }
            }
          }

          // Warte auf die Validierung
          try {
            await this.validateCart();
          } catch (error) {
            console.error("Fehler bei der Cart-Validierung:", error);
          }

          return response;
        }

        return originalFetch(...args);
      } catch (error) {
        console.error("Fetch Error:", error);
        return originalFetch(...args);
      }
    };

    // Prüfe, ob wir aktiv sind, bevor wir die initiale Validierung durchführen
    if (this.isActive) {
      this.validateCart().catch((error) => {
        console.error("Fehler bei der initialen Cart-Validierung:", error);
      });
    }
  }

  attachEventListeners() {
    if (!this.isActive) return;

    console.log("Attaching event listeners...");

    document
      .querySelectorAll("quantity-input.cart-quantity")
      .forEach((container) => {
        if (container.dataset.validatorInitialized) return;

        const input = container.querySelector(".quantity__input");
        const plusButton = container.querySelector('button[name="plus"]');
        const minusButton = container.querySelector('button[name="minus"]');

        console.log("Found quantity input:", input);
        console.log("Plus button:", plusButton);
        console.log("Minus button:", minusButton);

        if (input) {
          input.addEventListener("input", async (e) => {
            if (!this.isActive) return;
            console.log("Input changed:", e.target.value);
            await this.validateQuantityChange(input);
          });
        }

        if (plusButton) {
          plusButton.addEventListener("click", async () => {
            if (!this.isActive) return;
            console.log("Plus clicked");
            setTimeout(async () => {
              await this.validateQuantityChange(input);
            }, 100);
          });
        }

        if (minusButton) {
          minusButton.addEventListener("click", async () => {
            if (!this.isActive) return;
            console.log("Minus clicked");
            setTimeout(async () => {
              await this.validateQuantityChange(input);
            }, 100);
          });
        }

        container.dataset.validatorInitialized = "true";
      });
  }

  async validateQuantityChange(input) {
    if (!this.isActive) return;

    console.log("Validating quantity change...");
    const variantId = input.getAttribute("data-quantity-variant-id");
    const quantity = parseInt(input.value) || 0;
    const errorContainer = input
      .closest("quantity-popover")
      ?.querySelector(".cart-item__error-text");
    const isInCart = input
      .closest("quantity-input")
      ?.classList.contains("cart-quantity");

    try {
      const variantData = await this.getVariantData(variantId);
      if (!variantData) return;

      const originalSku = variantData.sku;
      console.log("Original SKU from Shopify:", originalSku);

      // Wenn keine SKU vorhanden ist, überspringe die Validierung
      if (!originalSku || originalSku.trim() === "") {
        console.log("Keine SKU vorhanden, überspringe Validierung");
        return;
      }

      const apiData = await this.getApiInventory(originalSku);

      // Prüfe, ob das Rohwarenbestand-Metafield in der API-Antwort vorhanden und true ist
      const hasRohwarenbestand = this.hasRohwarenbestandMetafield(apiData);

      if (!hasRohwarenbestand) {
        console.log(
          "Rohwarenbestand-Metafield nicht aktiv für diese SKU, überspringe Validierung"
        );
        return;
      }

      console.log("=== Bestandsübersicht ===");
      console.log(
        `Shopify Lagerbestand: ${apiData.originalSku?.availableQuantity || 0}`
      );
      console.log(`Externer Bestand: ${apiData.quantity || 0}`);
      console.log(
        `Gesamtbestand: ${
          (apiData.originalSku?.availableQuantity || 0) +
          (apiData.quantity || 0)
        }`
      );
      console.log("=====================");

      const baseQuantity = apiData.quantity || 0;
      const originalQuantity = apiData.originalSku?.availableQuantity || 0;
      const totalAvailable = baseQuantity + originalQuantity;

      if (quantity > totalAvailable) {
        if (errorContainer) {
          errorContainer.textContent = `Maximal verfügbare Menge: ${totalAvailable} (Lager: ${originalQuantity}, Extern: ${baseQuantity})`;
          errorContainer
            .closest(".cart-item__error")
            .setAttribute("hidden", isInCart);
        }

        // Setze den Wert, ohne ein Event auszulösen
        input.value = totalAvailable;

        // Füge ein verzögertes Event hinzu, um die Aktualisierung im Warenkorb zu triggern
        setTimeout(() => {
          input.dispatchEvent(new Event("change", { bubbles: true }));
        }, 0);

        // Zeige Modal nur im Cart
        if (isInCart) {
          this.showModal(
            `Die maximale Bestandsmenge für diesen Artikel beträgt ${totalAvailable} (Lager: ${originalQuantity}, Extern: ${baseQuantity}). Sie können keine weiteren Artikel hinzufügen.`
          );
        }
      } else {
        // Verstecke die Fehlermeldung wenn die Menge in Ordnung ist
        if (errorContainer) {
          errorContainer
            .closest(".cart-item__error")
            .setAttribute("hidden", "");
        }
      }
    } catch (error) {
      console.error("Fehler bei der Mengenvalidierung:", error);
    }
  }

  // Hilfsmethode zur Prüfung des Rohwarenbestand-Metafields in der API-Antwort
  hasRohwarenbestandMetafield(apiData) {
    if (!apiData) return false;

    // Fall 1: Prüfe, ob das Metafield in der direkten API-Antwort vorhanden ist (Variantenebene)
    if (apiData.metafields && Array.isArray(apiData.metafields)) {
      const variantMetafield = apiData.metafields.find(
        (metafield) =>
          metafield.namespace === "custom" &&
          metafield.key === "rohwarenbestand"
      );

      if (
        variantMetafield &&
        (variantMetafield.value === "true" || variantMetafield.value === true)
      ) {
        console.log("Rohwarenbestand auf Variantenebene aktiviert");
        return true;
      }
    }

    // Fall 2: Prüfe, ob das Metafield in der originalSku-Ebene vorhanden ist (Produktebene)
    if (
      apiData.originalSku &&
      apiData.originalSku.metafields &&
      Array.isArray(apiData.originalSku.metafields)
    ) {
      const productMetafield = apiData.originalSku.metafields.find(
        (metafield) =>
          metafield.namespace === "custom" &&
          metafield.key === "rohwarenbestand"
      );

      if (
        productMetafield &&
        (productMetafield.value === "true" || productMetafield.value === true)
      ) {
        console.log("Rohwarenbestand auf Produktebene aktiviert");
        return true;
      }
    }

    // Fall 3: Prüfe das produktweite Metafield, falls es in apiData.product vorhanden ist
    if (
      apiData.product &&
      apiData.product.metafields &&
      Array.isArray(apiData.product.metafields)
    ) {
      const productWideMetafield = apiData.product.metafields.find(
        (metafield) =>
          metafield.namespace === "custom" &&
          metafield.key === "rohwarenbestand"
      );

      if (
        productWideMetafield &&
        (productWideMetafield.value === "true" ||
          productWideMetafield.value === true)
      ) {
        console.log("Rohwarenbestand global für das Produkt aktiviert");
        return true;
      }
    }

    return false;
  }

  async validateCart() {
    if (!this.isActive) return;

    try {
      const cartResponse = await fetch("/cart.js");
      const cartData = await cartResponse.json();
      let wasUpdated = false;

      for (const item of cartData.items) {
        const variantData = await this.getVariantData(item.variant_id);
        if (!variantData) continue;

        // Wenn keine SKU vorhanden ist, überspringe die Validierung
        if (!variantData.sku || variantData.sku.trim() === "") {
          console.log(
            `Artikel ${item.title} hat keine SKU, überspringe Validierung`
          );
          continue;
        }

        const apiData = await this.getApiInventory(variantData.sku);

        // Prüfe, ob das Rohwarenbestand-Metafield in der API-Antwort vorhanden und true ist
        const hasRohwarenbestand = this.hasRohwarenbestandMetafield(apiData);

        if (!hasRohwarenbestand) {
          console.log(
            `Artikel ${item.title} hat kein aktives Rohwarenbestand-Metafield, überspringe Validierung`
          );
          continue;
        }

        const baseQuantity = apiData.quantity || 0;
        const originalQuantity = apiData.originalSku?.availableQuantity || 0;
        const totalAvailable = baseQuantity + originalQuantity;

        console.log(`=== Bestandsübersicht für ${variantData.sku} ===`);
        console.log(`Shopify Lagerbestand: ${originalQuantity}`);
        console.log(`Externer Bestand: ${baseQuantity}`);
        console.log(`Gesamtbestand: ${totalAvailable}`);
        console.log(`Im Warenkorb: ${item.quantity}`);
        console.log("=====================================");

        if (item.quantity > totalAvailable) {
          console.log(`Correcting quantity for ${variantData.sku}`);
          wasUpdated = true;

          await fetch("/cart/change.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              id: item.key,
              quantity: totalAvailable,
            }),
          });

          this.showModal(
            `Sorry, der Artikel ${item.title} liegt nur noch ${totalAvailable} Mal in unserem Laderaum.`
          );
        }
      }

      // Wenn der Cart aktualisiert wurde, aktualisiere auch den Cart-Count
      if (wasUpdated) {
        const updatedCartResponse = await fetch("/cart.js");
        const updatedCartData = await updatedCartResponse.json();
        this.updateCartCount(updatedCartData.item_count);
      }
    } catch (error) {
      console.error("Fehler bei der Warenkorb-Validierung:", error);
    }
  }

  async validateCartAdd(addResponse) {
    if (!this.isActive) return false;

    try {
      // Prüfe, ob addResponse und items existieren
      if (!addResponse || !addResponse.items || !addResponse.items.length) {
        console.log("Keine gültigen Items in der Antwort gefunden");
        return false;
      }

      // Hole die hinzugefügte Variante
      const variant = addResponse.items[addResponse.items.length - 1];
      const variantData = await this.getVariantData(variant.variant_id);
      if (!variantData) return false;

      // Wenn keine SKU vorhanden ist, überspringe die Validierung
      if (!variantData.sku || variantData.sku.trim() === "") {
        console.log(
          `Artikel ${variant.title} hat keine SKU, überspringe Validierung`
        );
        return false;
      }

      const apiData = await this.getApiInventory(variantData.sku);

      // Prüfe, ob das Rohwarenbestand-Metafield in der API-Antwort vorhanden und true ist
      const hasRohwarenbestand = this.hasRohwarenbestandMetafield(apiData);

      if (!hasRohwarenbestand) {
        console.log(
          `Hinzugefügter Artikel ${variant.title} hat kein aktives Rohwarenbestand-Metafield, überspringe Validierung`
        );
        return false;
      }

      const baseQuantity = apiData.quantity || 0;
      const originalQuantity = apiData.originalSku?.availableQuantity || 0;
      const totalAvailable = baseQuantity + originalQuantity;

      console.log(`=== Bestandsübersicht für ${variantData.sku} ===`);
      console.log(`Shopify Lagerbestand: ${originalQuantity}`);
      console.log(`Externer Bestand: ${baseQuantity}`);
      console.log(`Gesamtbestand: ${totalAvailable}`);
      console.log(`Angeforderte Menge: ${variant.quantity}`);
      console.log("=====================================");

      if (variant.quantity > totalAvailable) {
        return {
          needsUpdate: true,
          totalAvailable,
          baseQuantity,
          originalQuantity,
        };
      }

      return false;
    } catch (error) {
      console.error("Fehler bei der Add-to-Cart Validierung:", error);
      return false;
    }
  }

  updateCartCount(count) {
    if (!this.isActive) return;

    // Aktualisiere alle Cart-Count-Bubbles im Header
    document.querySelectorAll(".cart-count-bubble").forEach((bubble) => {
      // Update sichtbare Zahl
      const visibleSpan = bubble.querySelector('span[aria-hidden="true"]');
      if (visibleSpan) {
        visibleSpan.textContent = count;
      }

      // Update Screen Reader Text
      const srSpan = bubble.querySelector(".visually-hidden");
      if (srSpan) {
        srSpan.textContent = count === 1 ? "1 Artikel" : `${count} Artikel`;
      }
    });

    // Verstecke Bubbles wenn Cart leer ist
    if (count === 0) {
      document.querySelectorAll(".cart-count-bubble").forEach((bubble) => {
        bubble.style.display = "none";
      });
    } else {
      document.querySelectorAll(".cart-count-bubble").forEach((bubble) => {
        bubble.style.display = "flex";
      });
    }
  }

  async getVariantData(variantId) {
    try {
      const response = await fetch(`/variants/${variantId}.js`);
      if (!response.ok) throw new Error("Variant API Fehler");
      const data = await response.json();
      // Reduziere Logging um unnötige Konsolenausgaben zu vermeiden
      // console.log("Shopify variant data:", data);
      return data;
    } catch (error) {
      console.error("Fehler beim Laden der Variant-Daten:", error);
      return null;
    }
  }

  async getApiInventory(sku) {
    // Wenn SKU null, leer oder nicht definiert ist, nicht die API aufrufen
    if (!sku || sku.trim() === "") {
      console.log("Keine gültige SKU vorhanden, überspringe API-Abfrage");
      return {
        quantity: 0,
        available: false,
        originalSku: null,
        metafields: [],
      };
    }

    // Cache-Zugriff für vorhandene SKUs
    if (this.inventoryCache.has(sku)) {
      return this.inventoryCache.get(sku);
    }

    try {
      console.log(`Rufe API für SKU "${sku}" auf`);
      const response = await fetch(
        `https://api.stoertebeker.platzdorsch.io/api/inventory/${sku}`
      );
      if (!response.ok) throw new Error("API Fehler");
      const data = await response.json();
      this.inventoryCache.set(sku, data);
      return data;
    } catch (error) {
      console.error(`Fehler beim Laden der API-Daten für SKU "${sku}":`, error);
      // Rückgabe eines Standardobjekts bei Fehler
      return {
        quantity: 0,
        available: false,
        originalSku: null,
        metafields: [],
      };
    }
  }
}

// Initialisiere den Validator
new CartQuantityValidator();
